import './FeatureSection.css';
import { FaSearch, FaShieldAlt, FaClipboardCheck } from 'react-icons/fa';

function FeatureSection() {
  return (
    <div className="feature-section">
      <div className="feature">
        <FaSearch className="feature-icon" />
        <h3>Uncover key details</h3>
        <p>Find out important information about the job and company.</p>
      </div>
      <div className="feature">
        <FaShieldAlt className="feature-icon" />
        <h3>Verify validity</h3>
        <p>Determine if a job listing is genuine and trustworthy.</p>
      </div>
      <div className="feature">
        <FaClipboardCheck className="feature-icon" />
        <h3>Assist your decision</h3>
        <p>Get insight to help you decide if the job is right for you.</p>
      </div>
    </div>
  );
}

export default FeatureSection;
